// =========================================================
// Citation source registry — cite-id → source metadata
// =========================================================
//
// Resolves citation labels produced by AI answers into a renderable source
// snapshot: human title, an excerpt for the drawer, and citation metadata
// (date, author, confidence).
//
// Consumer: the AIRail's answer citations (CitationChip → 'citation' drawer).
// New cite IDs land here. The mock corpus is intentionally small — replace
// these demo sources with your product's reference documents.

export type CitationConfidence = 'high' | 'medium' | 'inferred';

export type CitationSource = {
  /** Stable id used inside citation labels. */
  id: string;
  /** Human title for the chip's hover preview header. */
  title: string;
  /** Source filename shown in the drawer. */
  documentFilename: string;
  /** Excerpt rendered in the citation drawer. */
  excerpt: string;
  /** ISO date of the source. */
  date: string;
  author: string;
  confidence: CitationConfidence;
};

const SOURCES: CitationSource[] = [
  {
    id: 'DOC-001',
    title: 'Product design brief',
    documentFilename: 'design-brief.pdf',
    excerpt:
      'The workspace uses a three-panel layout: sidebar on the left, the active scene in the centre, and the docked chat rail on the right.',
    date: '2026-07-01',
    author: 'Design team',
    confidence: 'high',
  },
  {
    id: 'DOC-002',
    title: 'Requirements note — v1 scope',
    documentFilename: 'requirements-v1.md',
    excerpt:
      'v1 ships the scaffold only: navigation chrome, one example module, the build-doc drawer, and the comments overlay.',
    date: '2026-07-15',
    author: 'Product team',
    confidence: 'medium',
  },
];

const BY_ID = new Map(SOURCES.map((s) => [s.id, s]));

export function getCitationSource(id: string): CitationSource | undefined {
  return BY_ID.get(id);
}

export function allCitationSources(): readonly CitationSource[] {
  return SOURCES;
}
